import Styled from 'styled-components';

import { VALID_COLOR } from '../../lib/StyledComponents';
import { SmallType } from '../Typography';

export interface IPillProps {
  pillColor: VALID_COLOR;
  margin?: string;
}

export const Pill = Styled(SmallType)<IPillProps>`
  display: inline-flex;
  border-radius: ${({ theme: { pill }}) => pill.borderRadius};
  font-size: ${({ theme: { pill } }) => pill.fontSize};
  font-weight: 700;
  padding: ${({ theme: { pill }}) => pill.padding};
  margin: ${({ margin }) => margin};
  vertical-align: center;
  align-items: center;
  text-align: center;
  text-transform: ${({ theme: { pill }}) => pill.textTransform};
  background-color: ${({theme: { pill }, pillColor}) => pill[pillColor].colorBackground};
  color: ${({theme: { pill }, pillColor}) => pill[pillColor].colorText};
  letter-spacing: ${({ theme: { pill }}) => pill.letterSpacing};
`;

Pill.defaultProps = {
  margin: '0 0.6em',
};
